enum StatusMensagem {
    Enviando = 0,
    Enviada = 1,
    Entregue = 2,
    Lida = 3,
}

export default StatusMensagem;
